import {Instance, types as t} from 'mobx-state-tree';
import {DoTestSentenceCompleteQuestion} from './do-test-sentence-complete-question.store';
import {FlowChartAnswerQuestion} from '../../../question-data-model/Question/_implementations/flowchart-question.store';

export const DoTestFlowChartQuestion = t
  .compose(DoTestSentenceCompleteQuestion, FlowChartAnswerQuestion)
  .named('DoTestFlowChartQuestion')
  .views((self) => ({
    get groupName() {
      return 'Flowchart Answer';
    },
  }));

export interface DoTestFlowChartQuestionInstance extends Instance<typeof DoTestFlowChartQuestion> {}
